import { useCallback, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { ReturnTypesTableContext } from '../contexts';

export const useReturnTypesActionBar = () => {
  const { selection, selectAll, fetch, reset, resetSelection } = useContext(ReturnTypesTableContext);

  const location = useLocation();
  const history = useHistory();

  const create = useCallback(() => {
    history.push('/@next/return-types/create', { background: location });
  }, [history, location]);

  return { selection, resetSelection, create, selectAll, reset, fetch };
};
